import type { TDatadogErrorLog } from 'utils/datadog/types'

export const WORKSPACE_GET_COMPANY_PLAN_LOG_ERROR: TDatadogErrorLog = {
  from: 'modules/territory/search-territory-page-selector',
  name: 'Get workspace data',
  message: 'Obtain the workspace data',
}
